/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Package } from '../models/package';
@Injectable({
  providedIn: 'root',
})
class PackagesService extends __BaseService {
  static readonly getPackagesLocationIdPath = '/packages/{locationId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * List all the packages
   * @param locationId undefined
   * @return successful operation
   */
  getPackagesLocationIdResponse(locationId: number): __Observable<__StrictHttpResponse<Array<Package>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/packages/${encodeURIComponent(String(locationId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Package>>;
      })
    );
  }
  /**
   * List all the packages
   * @param locationId undefined
   * @return successful operation
   */
  getPackagesLocationId(locationId: number): __Observable<Array<Package>> {
    return this.getPackagesLocationIdResponse(locationId).pipe(
      __map(_r => _r.body as Array<Package>)
    );
  }
}

module PackagesService {
}

export { PackagesService }
